export default "__VITE_ASSET__39a279cb__"